<template>
  <fieldset
    :key="thingThatICanIncrementToForceAnImmediateRedraw"
    class="starability-basic display"
    :class="{
      [`starability-basic--${size}`]: size,
    }"
  >
    <legend>Sternebewertung:</legend>
    <input
      :id="`rate5-${_uid}`"
      :class="{ checked: rating === 5 }"
      name="rating"
      value="5"
    />
    <label
      :for="`rate5-${_uid}`"
      title="AUSGEZEICHNET - Ich würde dies als das Gewinner-Design in Erwägung ziehen"
      aria-label="AUSGEZEICHNET - Ich würde dies als das Gewinner-Design in Erwägung ziehen"
      data-test-rating="excellent"
    >
      5 Sterne
    </label>
    <input
      :id="`rate4-${_uid}`"
      :class="{ checked: rating === 4 }"
      name="rating"
      value="4"
    />
    <label
      :for="`rate4-${_uid}`"
      title="SEHR GUT - Hochwertiges Design, das etwas nachbearbeitet werden muss"
      aria-label="SEHR GUT - Hochwertiges Design, das etwas nachbearbeitet werden muss"
      data-test-rating="very-good"
    >
      4 Sterne
    </label>
    <input
      :id="`rate3-${_uid}`"
      :class="{ checked: rating === 3 }"
      name="rating"
      value="3"
    />
    <label
      :for="`rate3-${_uid}`"
      title="GUT - guter Versuch aber nicht im Wettstreit, solange keine Änderungen vorgenommen werden"
      aria-label="GUT - guter Versuch aber nicht im Wettstreit, solange keine Änderungen vorgenommen werden"
      data-test-rating="good"
    >
      3 Sterne
    </label>
    <input
      :id="`rate2-${_uid}`"
      :class="{ checked: rating === 2 }"
      name="rating"
      value="2"
    />
    <label
      :for="`rate2-${_uid}`"
      title="SCHLECHT - Ich mag dieses Design nicht, aber würde gerne, dass es der Designer noch einmal versucht"
      aria-label="SCHLECHT - Ich mag dieses Design nicht, aber würde gerne, dass es der Designer noch einmal versucht"
      data-test-rating="poor"
    >
      2 Sterne
    </label>
    <input
      :id="`rate1-${_uid}`"
      :class="{ checked: rating === 1 }"
      name="rating"
      value="1"
    />
    <label
      :for="`rate1-${_uid}`"
      title="SEHR SCHLECHT - Design entspricht das Briefing nicht oder hat sehr geringe Qualität"
      aria-label="SEHR SCHLECHT - Design entspricht das Briefing nicht oder hat sehr geringe Qualität"
      data-test-rating="very-poor"
    >
      1 Stern
    </label>
  </fieldset>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: undefined,
    },
    rating: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      thingThatICanIncrementToForceAnImmediateRedraw: 0,
    };
  },
};
</script>
